import React from "react";
import Header from "../components/Header";

function Projects() {
  return (
    <div>
      <Header />
      <div className="section"> </div>

      <div className="card">
          <div className="ptitle">Pwa prototype reporting</div>
          <div className="pbody">
          The Core Idea of my project was to improve the accessibility of Primero v2 application and make this application accessible for everyone. Accessibility makes it easier for people to see, hear, and use a computer or device, and to customize their computing environment according to their own preferences, needs, and abilities.
            <br></br>
            Technologies Used: Reactjs, Redux, Material UI, Accessibility Tools
            <div className="pbottom">
              <a
                className="pbottom"
                href="https://github.com/ushahidi/pwa-prototype-reporting"
              >
                Code
              </a>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="ptitle">Pwa prototype reporting</div>
          <div className="pbody">
            This project started as an experimental prototype to migrate the
            functionality of Ushahidi survey submissions into a small standalone
            project that can be deployed anywhere and in the future could be
            linked to any ushahidi.io deployment chosen by the user.
            <br></br>
            Technologies Used: Nextjs,Reactjs
            <div className="pbottom">
              <a
                className="pbottom"
                href="https://github.com/ushahidi/pwa-prototype-reporting"
              >
                Code
              </a>
            </div>
          </div>
        </div>
     

      <div className="card">
        <div className="ptitle">Platform ReactJS Migration</div>

        <div className="pbody">
          The goal of this project is to move the existing functionality of the
          angular code over to react. The new components will be using web
          standards as much as possible, avoiding extensive use of third-party
          libraries.
          <br></br> Technologies Used: Angular 1, Reactjs, Redux
          <div className="pbottom">
            <a
              className="pbottom"
              href="https://github.com/ushahidi/platform-client/tree/js-migration"
            >
              Code
            </a>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="ptitle">React Flowchart</div>

        <div className="pbody">
          This project uses js plumb library to implement drag and drop feature.
          Using this the user can make the flowcharts.
          <br></br>Technologies Used: HTMl, CSS, Javascript
          <div className="pbottom">
            <a
              className="pbottom"
              href="https://github.com/NidhiKJha/flowChart.github.io"
            >
              Code
            </a>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="ptitle">Todo App</div>

        <div className="pbody">
          A Todo App where the users can add a task and then remove it when it's
          completed.
          <br></br> Technologies Used: Javascript, Typescript, React-hooks, SASS
          <div className="pbottom">
            <a className="pbottom" href="https://github.com/NidhiKJha/todo-app">
              Code
            </a>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="ptitle">Bond Trading App</div>

        <div className="pbody">
          This project is a bond trading app where the users can buy or sell a
          bond.
          <br></br>Technologies Used: SASS,Reactjs, Redux
        </div>
      </div>
      <div className="prsection">
        <a className="pbottom" href="https://github.com/NidhiKJha">
          Checkout my github
        </a>
      </div>
    </div>
  );
}

export default Projects;
